module.exports = {
    "source_code": "HLXEMS",
    "site_id": "explore.txchiro.edu",
    "title": "Texas Chiropractic College",
    "tfn": "",
    "url": "https://explore.txchiro.edu",
    "gtm_code": "GTM-TJ8K324",
}